import { z } from 'zod'

// Validação das envs do Vite — todas DEVEM ter o prefixo VITE_.
// Roda no boot do main.tsx; aborta se algo essencial faltar.

const envSchema = z.object({
  VITE_API_BASE_URL: z.string().url(),
  VITE_AUTH_BASE_URL: z.string().url(),
  // ID do pixel do Facebook. Opcional: ausente = pixel desligado (dev/staging).
  VITE_FB_PIXEL_ID: z.string().optional(),
  // ID do projeto Microsoft Clarity. Opcional: ausente = Clarity desligado (dev/staging).
  VITE_CLARITY_PROJECT_ID: z.string().optional(),
})

const parsed = envSchema.safeParse(import.meta.env)

if (!parsed.success) {
  console.error('✗ Envs do front inválidas:')
  for (const issue of parsed.error.issues) {
    console.error(`  - ${issue.path.join('.')}: ${issue.message}`)
  }
  throw new Error('Configuração de env inválida — veja console.')
}

export const env = parsed.data
